import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import LandingPageHero from "../components/LandingPageHero";
import HomeProblemSection from "../components/HomeProblemSection";
import HomeServiceTiersSection from "../components/HomeServiceTiersSection";
import HomeSocialProofBanner from "../components/HomeSocialProofBanner";
import HomeHowItWorksSection from "../components/HomeHowItWorksSection";
import HomeTestimonialsHighlight from "../components/HomeTestimonialsHighlight";
import HomeFinalCtaSection from "../components/HomeFinalCtaSection";
import InterestCaptureModal from "../components/InterestCaptureModal";

const LandingPage: React.FC = () => {
  const { i18n } = useTranslation();
  const isKo = i18n.language === "ko";

  return (
    <div className="font-sans bg-white text-[#0A1A3E]">
      <Helmet>
        <title>
          {isKo
            ? "영국 취업 컨설팅 | CV · 커버레터 · LinkedIn — BeMe"
            : "UK Job Consulting | CV · Cover Letter · LinkedIn — BeMe"}
        </title>
        <meta
          name="description"
          content={
            isKo
              ? "영국 취업을 준비하는 한국인을 위한 전문 컨설팅. 영국 유학 후 취업, 워홀 커리어 전환, 한국 경력자 이직 — UK 리크루터 기준 CV 진단, 커버레터, LinkedIn 최적화. 10년차 영국 현직자가 함께합니다."
              : "UK job consulting for Korean professionals. CV, Cover Letter, LinkedIn and interview prep aligned with UK recruiter standards. Guided by a 10-year UK industry expert."
          }
        />
        <meta
          name="keywords"
          content={
            isKo
              ? "영국 취업, 영국 취업 컨설팅, 영국 CV, 영국 이력서, 영국 유학 후 취업, 워홀 취업, 한국인 영국 취업, 영국 커리어, 영국 취업 준비, 영국 취업 로드맵, 영국 취업 방법"
              : "UK job search, UK CV consulting, UK career, Korean professionals UK, cover letter UK, LinkedIn UK"
          }
        />
        <meta
          property="og:title"
          content={isKo ? "영국 취업 컨설팅 | BeMe Consulting" : "UK Job Consulting | BeMe Consulting"}
        />
        <meta
          property="og:description"
          content={
            isKo
              ? "영국 취업을 준비하는 한국인을 위한 전문 컨설팅. UK 리크루터 기준 CV 진단, 커버레터, LinkedIn 최적화."
              : "UK job consulting for Korean professionals. CV, Cover Letter and LinkedIn aligned with UK recruiter standards."
          }
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.bemeconsulting.com/" />
      </Helmet>
      <LandingPageHero />
      <HomeProblemSection />
      <HomeServiceTiersSection />
      <HomeSocialProofBanner />
      <HomeHowItWorksSection />
      <HomeTestimonialsHighlight />
      <HomeFinalCtaSection />
      <InterestCaptureModal sourcePage="landing" />
    </div>
  );
};

export default LandingPage;
